import { captureTRFPrintHandler } from 'helpers/FormHelpers/helper';
import _ from 'lodash';

export const handleFormPrint = async (setSpinnerVisible) => {
        setSpinnerVisible(true);
        const imgData1 = await handlePrintCapture();
        const iframe = document.createElement('iframe');
            iframe.style.height = 0;
            iframe.style.visibility = 'hidden';
            iframe.style.width = 0;
            iframe.style.overflowX = 'visible';
            iframe.setAttribute('srcdoc', '<html><body></body></html>');
            document.body.appendChild(iframe);
            iframe.addEventListener('load', () => {
              const { body } = iframe.contentDocument;
              const div = document.createElement('div');
              div.style.position = 'absolute';
              div.style.display = 'block';
              div.style.left = 0;
              div.style.top = 0;
              div.style.bottom = 0;
              div.style.right = 0;
              div.style.padding = 0;
              body.appendChild(div);
                const image = document.createElement('img');
                image.src = imgData1;
                image.setAttribute('id', 'img1');
                image.style.width = '100%';
                // maxHeight for Letter paper height (1054px - 2*48px(narrow margin size))
                image.style.maxHeight = '958px';
                div.insertAdjacentElement('beforeend', image);
            });
            setSpinnerVisible(false);
            iframe.contentWindow.print();
            iframe.contentWindow.addEventListener('beforeprint', () => {
              const images = iframe.contentWindow.document.querySelectorAll('img');
              _.forEach(images, (img) => {
                const ratio = img.naturalHeight / img.naturalWidth;
                // calculate the bottom margin to be added to image to make each image appear on distinct page
                // 958 is the max height mentioned above
                // 1.29 is the letter size ratio (1054/816)px
                if (ratio < 1.29) {
                  const margin = Math.abs(958 - (ratio / 1.29 * 958));
                  iframe.contentWindow.document.getElementById(img.id).style.marginBottom = `${margin}px`;
                }
              });
            });
            iframe.contentWindow.addEventListener('afterprint', () => {
              iframe.parentNode.removeChild(iframe);
            });
    };

const handlePrintCapture = async () => {
    const imgCanvas = await captureTRFPrintHandler();
    return imgCanvas.toDataURL('image/png');
};
